module.exports = __webpack_public_path__ + "691672ffea8a630c98ca73602f39419c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-420.webp.png
// module id = 538
// module chunks = 0